module.exports = __webpack_public_path__ + "img/emoji_55.72118234.png";